module.exports = __webpack_public_path__ + "img/berlinerkranse_dej.ce1755b7.jpg";